<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
        <span class="col-lg-6 m-0 p-0 text-left">
          <h4>{{ $t('banners') }}</h4>
        </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addBanner">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('banners')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
      <template #imageUrl="{item}">
        <td>
          <img v-if="item.imageUrl" :src="getImageUrl(item.imageUrl)" style="max-height: 40px; max-width: 80px;" />
        </td>
      </template>
      <template #active="{item}">
        <td>
          <CBadge :color="item.active ? 'success' : 'secondary'">{{ item.active ? $t('yes') : $t('no') }}</CBadge>
        </td>
      </template>
    </CTableWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import InputGetList from "@/classes/InputGetList";
import { API_HELPER } from "@/helpers/api.js";
import i18n from '@/helpers/i18n';

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'imageUrl', label: i18n.t('image'), sortable: false },
        { key: 'altText', label: i18n.t('altText'), sortable: true },
        { key: 'link', label: 'Link', sortable: true },
        { key: 'active', label: i18n.t('active'), sortable: true },
        { key: 'position', label: i18n.t('position'), sortable: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view'), icon: 'cil-magnifying-glass' },
        { key: 'edit', label: i18n.t('edit'), icon: 'cil-pencil' },
        { key: 'delete', label: i18n.t('delete'), icon: 'cil-trash' }
      ],
      sorterValue: { column: 'position', asc: true },
      loading: false
    }
  },
  computed: {
    ...mapState('banners', ['getBannersOutput']),
    ...mapState('banners', ['deleteBannerOutput']),
    bannersInfo: function() {
      return this.getBannersOutput && this.getBannersOutput.data ? this.getBannersOutput.data : null;
    },
    items: function()
    {
      return this.bannersInfo ? this.bannersInfo : [];
    },
    pages: function()
    {
      return this.getBannersOutput ? this.getBannersOutput.totalPages : 1;
    },
  },
  mounted: function()
  {
    this.loadBanners();
  },
  methods: {
    ...mapActions('banners', ['getBanners']),
    ...mapActions('banners', ['deleteBanner']),
    getImageUrl(path) {
      if (path && path.startsWith('http')) return path;
      return API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, path]);
    },
    loadBanners() {
      const input = new InputGetList();
      input.pageNumber = 1;
      input.pageSize = this.itemsPerPage;
      input.searchText = this.searchText;
      input.sorter = this.sorterValue.asc ? 'ascending' : 'descending';
      input.propertyName = this.sorterValue.column;

      this.getBanners(input);
    },
    rowClicked (item) {
      this.$router.push({name: "BannerEdit", query: { id: item.id } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        case 'edit':
        {
          this.$router.push({name: "BannerEdit", query: { id: item.id } });
          break;
        }
        case 'delete':
        {
          if(confirm(this.$i18n.t('confirmRemoveBanner'))){
            this.deleteBanner(item.id);
          }
          break;
        }
      }
    },
    addBanner() {
      this.$router.push({name: "BannerAdd"});
    },
    searchClicked(searchText) {
      this.searchText = searchText;
      this.loadBanners();
    },
    updateItemsRequested(pageNumber) {
      const input = new InputGetList();
      input.pageNumber = pageNumber;
      input.pageSize = this.itemsPerPage;
      input.searchText = this.searchText;
      input.sorter = this.sorterValue.asc ? 'ascending' : 'descending';
      input.propertyName = this.sorterValue.column;

      this.getBanners(input);
    },
    sorterValueChanged(sorterValue) {
      this.sorterValue = sorterValue;
      this.loadBanners();
    }
  },
  watch: {
    deleteBannerOutput: function() {
      if (this.deleteBannerOutput === true) {
        this.loadBanners();
      }
    }
  }
}
</script>
